import EntityActionTypes from 'app/entity/ActionTypes';
import reducer from 'app/entity/reducer';

export default {
  reducers: {
    entities: reducer,
  },
  actionTypes: EntityActionTypes,
};
